
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tour-tnf",
      function () {
        return require("private-next-pages/tour-tnf.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tour-tnf"])
      });
    }
  